export default __webpack_public_path__ + "static/media/import.b5d0e571.svg";